/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="file.model.ts" />

module Eseebase {
    export class FileService {
        //private baseUrl = 'http://eseebase.azurewebsites.net';
        private static fileToken: string;
        private static isLoadingFileToken: boolean;
        private blobToken: string;
        private blobBaseUrl: string;
        constructor(private $http: ng.IHttpService, private baseService: BaseService, private $q: ng.IQService, private $timeout: ng.ITimeoutService) { }

        public upload(associationNumber: string, departmentNumber: string, extractSelected: boolean, extractOnlySimData: boolean, fileId: string, fileNames: string, data: FormData, onProgress: Function) {
            return this.baseService.upload('file/{companyNumber}/' + associationNumber + '/' + departmentNumber + '/upload?extractSelected=' + (extractSelected ? 'true' : 'false') + '&extractSimData=' + (extractOnlySimData ? 'true' : 'false') + '&fileId=' + (fileId ? fileId : '') + '&fileNames=' + encodeURIComponent(fileNames), data, onProgress);
        }

        public submitFile(file: FileModel) {
            return this.baseService.post('file/{companyNumber}/process', file).then(f => { file.id = (<any>f.data).id; return f.data; });
        }

        public canOverwrite(associationNumber: string, departmentNumber: string, localizer: string) {
            return this.baseService.get('file/{companyNumber}/' + associationNumber + '/' + departmentNumber + '/' + localizer + '/canoverwrite').then(j => { return j.data });
        }

        public deleteFile(id: string) {
            return this.baseService.delete('file/{companyNumber}/' + id);
        }

        public getDetails(id: string) {
            return this.baseService.get('file/{companyNumber}/' + id + '/details').then(l => { return l.data });
        }

        public getFilesPaged(filter: ModelFilterViewModel, pageNumber: number) {
            return this.baseService.post('file/{companyNumber}/filterPaged?pageNumber=' + pageNumber, filter).then(files => { return files.data });
        }

        public getFiles(filter: ModelFilterViewModel) {
            return this.baseService.post('file/{companyNumber}/filter', filter).then(files => { return files.data });
        }

        public getFileErrors(fileId: string, pageNumber: number) {
            return this.baseService.get('file/{companyNumber}/' + fileId + '/errors?pageNumber=' + pageNumber).then(errors => { return errors.data });
        }

        public getDrawingExportErrors(fileId: string, pageNumber: number) {
            return this.baseService.get('file/{companyNumber}/' + fileId + '/DrawingExportErrors?pageNumber=' + pageNumber).then(errors => { return errors.data });
        }

        public getFileCoordinates(companyNumber: string, filter: ModelFilterViewModel) {
            return this.baseService.post('file/' + companyNumber + '/filtergps', filter).then(files => { return files.data });
        }

        public getFile(id: string) {
            return this.baseService.get('file/{companyNumber}/' + id).then(files => { return files.data });
        }

        public getOutdoorGeometry(id: string) {
            return this.baseService.get('file/{companyNumber}/' + id + '/outdoorgeometry').then(data => { return data.data });
        }

        public getApartmentsGeometry(id: string) {
            return this.baseService.get('file/{companyNumber}/' + id + '/apartmentsgeometry');
        }

        public getRoomGeometry(id: string) {
            return this.baseService.get('file/{companyNumber}/' + id + '/roomgeometry').then(data => { return data.data });
        }

        public getFileToken() {
            var vm = this;
            if (FileService.isLoadingFileToken) {
                return this.$timeout(() => {
                    return vm.getFileToken();
                }, 500).then(d => d);
            }
            else {
                if (FileService.fileToken == null) {
                    FileService.isLoadingFileToken = true;
                    return this.baseService.get('file/{companyNumber}/filetoken').then(data => {
                        FileService.fileToken = <string>data.data;
                        FileService.isLoadingFileToken = false;
                        return FileService.fileToken;
                    }, () => {
                        FileService.isLoadingFileToken = false;
                    });
                }
                else {
                    return this.$q((resolve, refect) => {
                        resolve(FileService.fileToken);
                    });
                }
            }
        }

        public getBlobToken() {
            var vm = this;
            return this.getStringPromise('file/{companyNumber}/blobtoken', this.blobToken).then(token => {
                vm.blobToken = token;
                return token;
            });
        }

        public getBlobBaseUrl() {
            var vm = this;
            return this.getStringPromise('file/{companyNumber}/blobstorage', this.blobBaseUrl).then(token => {
                vm.blobBaseUrl = token;
                return token;
            });
        }

        public getLocalizers(filter: ModelFilterViewModel) {
            return this.baseService.post('file/{companyNumber}/localizers', filter).then(localizers => { return localizers.data });
        }

        public createLocalizer(file: FileModel) {
            return this.baseService.post('file/{companyNumber}/create', file).then(d => d.data);
        }

        public refreshAttachment(associationId: string, departmentId: string, localizer: string) {
            if (associationId != null && associationId != '' && departmentId != null && departmentId != '' && localizer != null && localizer != '') {
                return this.baseService.post(`file/{companyNumber}/refreshAttachment?associationId=${associationId}&departmentId=${departmentId}&localizer=${localizer}`, {}).then(d => d.data);
            }
        }

        public getApartments(filter: ModelFilterViewModel) {
            return this.baseService.post('file/{companyNumber}/apartments', filter).then(apartments => { return apartments.data });
        }

        public rerunFile(fileId: string) {
            return this.baseService.post('file/{companyNumber}/' + fileId + '/rerun', null);
        }

        public hasCorrections(fileId: string) {
            return this.baseService.get('file/{companyNumber}/' + fileId + '/hascorrections').then(data => data.data);
        }

        public deleteByDepartment(associationNumber: string, departmentNumber: string) {
            return this.baseService.post('file/{companyNumber}/' + associationNumber + '/' + departmentNumber + '/delete', {}).then(f => f.data);
        }

        public enableInCanea(fileId: string) {
            return this.baseService.put('canea/{companyNumber}/' + fileId + '/enableincanea', null).then(d => d.data)
        }

        public disableInCanea(fileId: string) {
            return this.baseService.put('canea/{companyNumber}/' + fileId + '/disableincanea', null).then(d => d.data)
        }

        private getStringPromise(url: string, value: string): ng.IPromise<string> {
            var defer = this.$q.defer();
            var vm = this;
            if (value != null) {
                defer.resolve(value);
            }
            else {
                this.baseService.get(url).then(data => {
                    defer.resolve(<string>data.data);
                });
            }
            return <ng.IPromise<string>>defer.promise;
        }
    }

    FileService.$inject = ['$http', 'BaseService', '$q', '$timeout'];
    angular
        .module('eseebase')
        .service('FileService', FileService);
}